import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import React, { useEffect, useState } from "react";
import style from "css/mypage.module.css";

function Dropbox(props) {
  const onClick = ({ key }) => { };
  const [partilist, setpartilist] = useState([
    {
      label: "",
      key: "",
    },
  ]);

  useEffect(() => {
    let list = [];

    if (props.host !== "favorite_list") {
      list.push({
        label: (
          <div className={style.partilist_host}>
            <img
              alt=""
              src={process.env.REACT_APP_CLIENT_URL + "img/mypage/hostmark.png"}
              className={style.partilist_mark}
            />
            <p className={style.partilist_text}>{props.data.EMAIL}</p>
          </div>
        ),
        key: 0,
      });
    }

    if (props.data.PARTICIPANTS.length > 0) {
      props.data.PARTICIPANTS.map((datas, index) => {
        if (props.data.EMAIL === datas.EMAIL) {
        } else {
          list.push({
            label: (
              <div>
                <p
                  className={
                    props.host !== "favorite_list"
                      ? style.partilist_text2
                      : style.partilist_favorite
                  }
                >
                  {datas.EMAIL}
                </p>
              </div>
            ),

            key: index + 1,
          });
        }
      });
    }

    setpartilist(list);
  }, [props.data.PARTICIPANTS]);

  const items = partilist;
  return (
    <div>
      <Dropdown
        menu={{ items, onClick }}
      >
        <div
          style={
            props.hover
              ? {
                backgroundColor: "#333a38",
                border: "1px solid #333a38",
              }
              : { backgroundColor: "#eff3f2", border: "1px solid #eff3f2" }
          }
          onClick={(e) => e.preventDefault()}
          className={style.participantlist}
        >
          <Space
            style={props.hover ? { color: "#bbbbbb" } : { color: "#333333" }}
          >
            <img
              alt=""
              src={
                props.hover
                  ? process.env.REACT_APP_CLIENT_URL +
                  "img/mypage/participantw.png"
                  : process.env.REACT_APP_CLIENT_URL +
                  "img/mypage/participant.png"
              }
              className={style.partilist_img}
            />
            {props.count}
            <DownOutlined />
          </Space>
        </div>
      </Dropdown>
    </div>
  );
}

export default Dropbox;
